// React Core
import React from 'react'
import ReactDOM from 'react-dom'

// Componenets
import App from './component/App.jsx'

// CSS
import './index.css'

// Service Worker
import * as serviceWorker from './serviceWorker'

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({
    onUpdate: () => {
        window.location.reload(true)
    }
})
